const fp = require('lodash/fp');
const {
    minDonationAmount,
    maxDonationAmount,
} = require('../helpers/donation.js');

function roundAmount(amount) {
    // too small to round
    if (amount < 25) {
        return amount;
    }
    const roundBy = 5;
    return Math.round(amount / roundBy) * roundBy;
}

function convertAmount(ratesArray, fromCode, toCode, amount) {
    const rates = fp.flow(
        fp.map(item => [item.code, item.rate]),
        fp.fromPairs,
    )(ratesArray);
    const rate = rates[fromCode] / rates[toCode];
    return Math.max(Math.round(rate * amount), 1);
}

function convertAndRound(ratesArray, fromCode, toCode, amount) {
    if (!amount) {
        return amount;
    }
    if (fromCode === toCode) {
        return amount;
    }
    return roundAmount(convertAmount(ratesArray, fromCode, toCode, amount));
}

function convertDonationAmount(ratesArray, fromCode, toCode, amount) {
    if (!amount) {
        return amount;
    }
    const convertedAmount = convertAndRound(
        ratesArray,
        fromCode,
        toCode,
        amount,
    );
    const minAmount = minDonationAmount(toCode);
    if (convertedAmount < minAmount) {
        return minAmount;
    }
    const maxAmount = maxDonationAmount(toCode);
    if (convertedAmount > maxAmount) {
        return maxAmount;
    }
    return convertedAmount;
}

module.exports = {
    convertAmount,
    convertAndRound,
    convertDonationAmount,
    roundAmount,
};
